import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ExpandLess } from '@material-ui/icons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

export const CustomExpand = ({ items, styles, node }) => {
  const [itemsExpend, setItemsExpend] = useState(false);

  const renderItem = (item) => node ? node(item) :
    <Typography sx={{ fontWeight: 500, fontSize: '20px', ...styles }} key={`item${item?.id || item}`} data-testid="ItemName">{item.name || item.label || item}</Typography>;

  return (
    <>
      {items?.length && (
        items.length < 4 ?
          items.map(item => renderItem(item)) :
          itemsExpend ? items.map((item, index, array) => {
            return (index === array.length - 1) ?
              (
              <Box sx={{ display: 'flex' }} key={index}>
                {renderItem(item)}
                <IconButton size="small" onClick={e => {e.stopPropagation(); setItemsExpend(false);}} sx={{ display: 'relative', bottom: 2 }}
                            data-testid="ExpandLess">
                  <ExpandLess fontSize="small" />
                </IconButton>
              </Box>
            ) :
            renderItem(item);
          }) :
            items.slice(0, 3).map((item, index) => {
              return (index === 2) ?
               (
                <Box sx={{ display: 'flex' }} key={index}>
                  {renderItem(item)}
                  <IconButton size="small" onClick={e => {e.stopPropagation(); setItemsExpend(true);}} sx={{ display: 'relative', bottom: 2 }}
                              data-testid="ExpandMore">
                    <ExpandMoreIcon fontSize="small" />
                  </IconButton>
                </Box>
              ) :
              renderItem(item);
            })
      )}
    </>
  );
}

CustomExpand.propTypes = {
  items: PropTypes.array,
  styles: PropTypes.object,
  node: PropTypes.func
}
